import { Guard } from "@/modules/router/types/guard";

export { gameConsoleGuard };

const gameConsoleGuard: Guard = (permissions) =>
  permissions.canAccessGameConsole;
